import ListGroup from 'react-bootstrap/ListGroup';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { FaCheckCircle, FaInfoCircle, FaBell, FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa';
import { getNotificationTitle, getNotificationBody } from '../../services/notificationRegistry';

const getIcon = (badge) => {
    switch (badge) {
        case 'success':
            return <FaCheckCircle className="text-success" />;
        case 'warning':
            return <FaExclamationTriangle className="text-warning" />;
        case 'danger':
            return <FaTimesCircle className="text-danger" />;
        case 'info':
        default:
            return <FaInfoCircle className="text-primary" />;
    }
};

const ListenerNotifications = ({ notifications = [], loading = false, onMarkRead, onMarkAllRead, onDelete }) => {
    const hasUnread = notifications.some(n => n.read_at === null);

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" variant="secondary" />
            </div>
        );
    }

    if (notifications.length === 0) {
        return (
            <div className="text-center py-5">
                <FaBell size={40} className="text-muted mb-3" />
                <p className="text-muted">No notifications yet</p>
            </div>
        );
    }

    return (
        <div>
            {hasUnread && onMarkAllRead && (
                <div className="d-flex justify-content-end mb-2">
                    <Button variant="link" size="sm" className="p-0 text-secondary" onClick={onMarkAllRead}>
                        Mark all as read
                    </Button>
                </div>
            )}
            <ListGroup variant="flush">
                {notifications.map((notification) => {
                    const isUnread = notification.read_at === null;
                    const body = getNotificationBody(notification.data);
                    const title = getNotificationTitle(notification.data);
                    const timestamp = new Date(notification.created_at).toLocaleDateString();

                    return (
                        <ListGroup.Item
                            key={notification.id}
                            className={`d-flex align-items-start ${isUnread ? 'bg-light' : ''}`}
                            style={{ cursor: isUnread && onMarkRead ? 'pointer' : 'default' }}
                            onClick={() => isUnread && onMarkRead && onMarkRead(notification.id)}
                        >
                            <div className="me-3 mt-1 flex-shrink-0">
                                {getIcon(notification.data?.badge)}
                            </div>
                            <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                    <h6 className="mb-1">
                                        {title}
                                        {isUnread && (
                                            <Badge bg="primary" className="ms-2">New</Badge>
                                        )}
                                    </h6>
                                    <div className="d-flex align-items-center gap-2 ms-2 flex-shrink-0">
                                        <small className="text-muted">{timestamp}</small>
                                        {onDelete && (
                                            <button
                                                type="button"
                                                className="btn-close"
                                                style={{ fontSize: '0.6rem' }}
                                                aria-label="Delete"
                                                onClick={(e) => { e.stopPropagation(); onDelete(notification.id); }}
                                            />
                                        )}
                                    </div>
                                </div>
                                {body && <p className="mb-0 text-muted small">{body}</p>}
                            </div>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        </div>
    );
};

export default ListenerNotifications;
